import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class AuthService {

    static getAuth(email) {
        var data = {
            email: email
        };
        return axios.post(`${BaseUrl}Auth`, data,
        {
            headers: {
            'email': email
        }});
    }
}


// WEBPACK FOOTER //
// ./src/Services/authService/authService.js